/**
 * Guard functions for the auto-title feature in LeftBar.
 * Extracted for testability.
 */

/**
 * Determines whether auto-titling should be initiated.
 * @param {boolean} editingProjectTitle - Whether the user is currently editing the project title
 * @param {boolean} editingTitle - Whether the user is currently editing a document title
 * @param {boolean} isUntitled - Whether the project is currently untitled
 * @param {string|null} projectTitle - The generated project title (from generateProjectTitle)
 * @returns {boolean}
 */
export function shouldAutoTitle(editingProjectTitle, editingTitle, isUntitled, projectTitle) {
  return !editingProjectTitle && !editingTitle && isUntitled && !!projectTitle;
}

/**
 * After the delay, re-checks whether the auto-title should proceed.
 * If the user manually renamed the project during the delay, bail out.
 * @param {boolean} isUntitled - Whether the project is STILL untitled at callback time
 * @returns {boolean}
 */
export function shouldProceedAfterDelay(isUntitled) {
  return isUntitled;
}
